var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRatingScale = function SvgRatingScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 7,
    viewBox: "0 0 25 7"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M5.227 2.5h3.485M14.288 2.5h3.485"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.439,
    cy: 2.5,
    rx: 2.439,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 2.5,
    rx: 2.439,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.561,
    cy: 2.5,
    rx: 2.439,
    ry: 2.5
  }))));
};
export default SvgRatingScale;